import { graphql } from "react-relay";

export const UNPUBLISHED_LEARNABLE_FRAGMENT = graphql`
	fragment editCourseLearnableButton_UnpublishedLearnableFragment on UnpublishedLearnable {
		id
		... on UnpublishedCourseLearnable {
			kind
			root {
				id
			}
		}
	}
`;
